var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75009 8.27501L2.12509 5.65001C1.83259 5.35751 1.36759 5.35751 1.07509 5.65001C0.782588 5.94251 0.782588 6.40751 1.07509 6.70001L4.21759 9.84251C4.51009 10.135 4.98259 10.135 5.27509 9.84251L13.2251 1.90001C13.5176 1.60751 13.5176 1.14251 13.2251 0.850005C12.9326 0.557505 12.4676 0.557505 12.1751 0.850005L4.75009 8.27501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTick);
export default __webpack_public_path__ + "static/media/white-tick.a670c7fdf3d62173b9883f1475e157ef.svg";
export { ForwardRef as ReactComponent };